import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function setQuotationVerticalSwiper() {
  const sections = document.querySelectorAll('[data-quotation-vertical]');

  sections.forEach((section) => {
    const swiperEl = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');
    const next = section.querySelector('.swiper-button-next');
    const prev = section.querySelector('.swiper-button-prev');

    if (swiperEl) {
      const carousel = new Swiper(swiperEl, {
         modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 16,
        speed: 1000,
        watchOverflow: true,
        centerInsufficientSlides: true,
        pagination: {
          el: pagination,
          type: "bullets",
          clickable: true,
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          991: {
            slidesPerView: 4,
          },
          1330: {
            slidesPerView: 5,
          },
        },
      });
    }
  });
}
 
